import * as React from 'react';

import {Button} from 'shells/button/button';
import {Illustration} from 'shells/illustrations/illustration';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import styles from './no-audiences-empty-state.module.css';

type Props = {
    onAddAudience: () => void;
};

export function NoAudiencesEmptyState(props: Props) {
    return (
        <StackLegacy spacing={16} alignCenter={true}>
            <div className={styles['illustration-container']}>
                <Illustration src='checklist-lady' />
            </div>
            <StackLegacy spacing={12} alignCenter={true}>
                <div className={styles.description}>
                    <Body color='light' size='small'>
                        You haven’t added any audiences to your preference center.
                    </Body>
                </div>
                <Button variant='primary' onClick={props.onAddAudience} size='big'>
                    Add your first audience
                </Button>
            </StackLegacy>
        </StackLegacy>
    );
}
